export const MEDCHART_TERMS = 'https://www.medchart.com/terms';
export const MEDCHART_PRIVACY = 'https://www.medchart.com/privacy';
export const MEDCHART = 'https://www.medchart.com/';

export const HEALTH_GORILLA = 'https://www.healthgorilla.com/home/platform/';
export const HEALTH_GORILLA_TERMS =
  'https://www.healthgorilla.com/home/legal/#tab-1';
export const HEALTH_GORILLA_PRIVACY =
  'https://www.healthgorilla.com/home/legal/#tab-2';

export const VALIDIC = 'https://validic.com';
export const VALIDIC_TERMS = 'https://validic.com/terms-conditions/';
export const VALIDIC_PRIVACY = 'https://validic.com/privacy-policy/';
export const TERRA_PRIVACY = 'https://tryterra.co/privacy';

export const VITALL_TERMS = 'https://www.vitall.com/legal#terms-and-conditions';
export const VITALL_PRIVACY = 'https://www.vitall.com/legal#privacy-notice';
export const VITALL_ABOUT = 'https://www.vitall.com/about';
export const VITALL_HELP = 'https://www.vitall.com/support';
